import { useEffect, useState } from "react";
import { Globe } from "lucide-react";
import {
  TRANSLATE_LANGUAGES,
  loadTranslateWidget,
  readTranslateLang,
  setTranslateLang,
} from "@/lib/translate";

export function LanguageSwitcher({ className = "" }: { className?: string }) {
  const [current, setCurrent] = useState("");

  useEffect(() => {
    const active = readTranslateLang();
    setCurrent(active);
    // Only contact Google Translate when a translation is actually active.
    // Loading it eagerly would pull in a third party for visitors who never
    // asked for one. Picking a language reloads the page, and
    // TranslationRuntime loads the widget from the stored choice.
    if (active) void loadTranslateWidget();
  }, []);

  return (
    <div className={`notranslate inline-flex flex-col gap-1 ${className}`}>
      <div className="relative inline-flex items-center gap-2">
        <Globe className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
        <label htmlFor="language-switcher" className="sr-only">
          Choose language
        </label>
        <select
          id="language-switcher"
          value={current}
          onChange={(e) => setTranslateLang(e.target.value)}
          aria-describedby="language-switcher-note"
          className="notranslate min-h-11 rounded-sm border border-border bg-transparent py-1 pl-2 pr-6 text-sm text-muted-foreground transition-colors hover:text-foreground focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
        >
          {TRANSLATE_LANGUAGES.map((l) => (
            <option key={l.code || "en"} value={l.code} className="bg-card text-foreground">
              {l.code ? `${l.label} (machine translation)` : l.label}
            </option>
          ))}
        </select>
      </div>
      <p id="language-switcher-note" className="max-w-xs text-xs text-muted-foreground">
        Machine translation, beta. Only the app's own labels and copy are translated — your
        entries, contacts and business names are never sent to the translation service.

      </p>
    </div>
  );
}
